<template>
  <div class="table-responsive" style="overflow: visible;">
    <table class="table table-base">
      <thead id="general">
        <tr>
          <th
            v-for="(head, key) in headers"
            :key="key"
            :class="[head.class, { 'th-filter': head.filter }]"
            :id="`${key}-head`"
          >
            <base-dropdown-select
              v-if="head.filter"
              :options="head.options"
              :title="head.title"
              :selected="head.selected"
              @input="event => filterData(key, event)"
            >
            </base-dropdown-select>
            <span
              v-else-if="head.sorting"
              class="sortable"
              :class="[{ 'is-sorted': getIsActiveSorted(key) }, getSortingOrder(key)]"
              @click="sort(key)"
            >
              {{ head.title }}
              <span class="dropdown-toggle"></span>
            </span>
            <template v-else>{{ head.title }}</template>
          </th>
          <th class="th-edit" :id="`edit-head`"></th>
        </tr>
      </thead>
      <tbody ref="tbody">
        <slot name="tbody"></slot>
        <tr v-if="noData">
          <td :colspan="colsCount" class="p-4">{{ $t('src/base/basetable.9091') }}</td>
        </tr>
        <!-- <tr v-else-if="loading">
          <td :colspan="colsCount" class="p-4 text-center">
            <base-spinner></base-spinner>
          </td>
        </tr> -->
      </tbody>
    </table>
  </div>
</template>

<script>
import('@/styles/components/table.less')
import('@/styles/components/terms.less')

export default {
  name: 'BaseTable',
  components: {
    BaseDropdownSelect: () => import('@/base/BaseDropdownSelect.vue')
  },
  props: {
    headers: {
      type: Object,
      required: true
    },
    addEmptyTh: {
      type: Boolean,
      default: true
    },
    noData: {
      type: Boolean,
      required: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    },
    sorting: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    localSorting: null,
    sortedHeads: new Map()
  }),
  created() {
    if (this.sorting) {
      this.localSorting = Object.assign({}, this.sorting)
    }
    this.setSortedHeads()
  },
  watch: {
    loading() {
      if (!this.loading) this.setIsReady()
    }
  },
  updated() {
    this.$nextTick(() => {
      this.setIsReady()
    })
  },
  computed: {
    colsCount() {
      return Object.keys(this.headers).length + 1
    }
  },
  methods: {
    setIsReady() {
      if (!this.$slots.tbody && this.noData && !this.loading) {
        this.$emit('isReady', true)
      }
      if (this.$slots.tbody && this.$slots.tbody[0].data && !this.loading) {
        this.setHeightRows()
        this.$emit('isReady', true)
      }
    },
    setHeightRows() {
      let biggestRowHeight = 0
      for (let row = 0; row < this.$refs.tbody.rows.length; row++) {
        let rowHeight = parseInt(this.$refs.tbody.rows[row].offsetHeight)
        if (rowHeight > biggestRowHeight) {
          biggestRowHeight = rowHeight
        }
      }
      for (let row = 0; row < this.$refs.tbody.rows.length; row++) {
        this.$refs.tbody.rows[row].style.height = biggestRowHeight + 'px'
      }
    },
    filterData(key, value) {
      this.emitFilter(key, value)
    },
    emitFilter(key, value) {
      this.$emit('filter', {
        key: key,
        value: value
      })
    },
    setSortedHeads() {
      // eslint-disable-next-line no-unused-vars
      for (let key in this.headers) {
        if (this.headers[key].sorting) {
          this.sortedHeads.set(key, this.headers[key].sorting)
        }
      }
    },
    getSortingOrder(headKey) {
      if (!this.sortedHeads.has(headKey)) {
        return ''
      }
      return this.sortedHeads.get(headKey)
    },
    getIsActiveSorted(headKey) {
      return this.localSorting.by === headKey
    },
    sort(headKey) {
      let order = this.sortedHeads.get(headKey)
      if (this.getIsActiveSorted(headKey)) {
        order = order === 'asc' ? 'desc' : 'asc'
        this.sortedHeads.set(headKey, order)
      }
      this.localSorting.by = headKey
      this.localSorting.order = order
      this.$emit('sorting', this.localSorting)
    }
  }
}
</script>
